import { GoArrowRight } from 'react-icons/go'
import DropdownSearch from '../components/dropdownSearch'
import Courses from '../components/courses'
import Heading from '../components/heading'
import { useRef } from 'react'
import { useInView } from 'framer-motion'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import ResearchSection from './researchSection'

const ChooseCourse = () => {
  const ref = useRef(null)
  const useIsInView = useInView(ref, { once: true })
  const state = useSelector(state => state.homepage)
  const data =
    state?.data?.properties?.belowVideoCTA?.items != null
      ? state?.data?.properties?.belowVideoCTA?.items[0]?.content?.properties
      : null
  return (
    <div
      className='w-full   h-full relative bg-white '
      style={{ borderRadius: '50px 50px 0 0' }}
    >
      <div className=' w-full  flex flex-col justify-center items-center p-8 gap-4'>
        {data != null && (
          <Link
            to={'/news & events'}
            className='w-full  flex justify-center items-center gap-4 '
          >
            <div className='w-6 p-1 h-6 text-white bg-red-900 rounded-full flex justify-center items-center '>
              <GoArrowRight />
            </div>
            <div className='text-red-600 font-bold underline hover:scale-110 transition-all duration-500 cursor-pointer'>
              {data?.label}
            </div>
          </Link>
        )}

        <div className='w-full  flex justify-center  items-center md:p-8'>
          <div
            ref={ref}
            className='w-full md:max-w-[60rem]  2xl:w-5/6 2xl:max-w-full flex flex-col justify-center items-center md:px-8'
          >
            <ResearchSection data={state?.data?.properties} />

            <div className='flex flex-col gap-2 items-center'>
              <Heading name='Programs' />
              <h1 className='text-3xl text-center font-bold'>
                Choose Your Course
              </h1>
            </div>
            <div className='w-full flex items-center relative my-16  md:my-8 py-8'>
              <div className=' w-full absolute  z-30 md:right-[4rem] lg:right-[0rem] 2xl:right-[5rem] h-fit  top-0  2xl:max-w-7xl 2xl:h-fit'>
                <DropdownSearch />
              </div>
            </div>
            <Courses useIsInView={useIsInView} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChooseCourse
